module.exports = __webpack_public_path__ + "img/discover.5959168c.png";